/** Customer contact helpers for invoice / recurring-invoice delivery options. */

function parseContactRows(contact) {
  if (!contact) return [];
  if (Array.isArray(contact)) return contact;
  if (typeof contact === "string") {
    try {
      const parsed = JSON.parse(contact);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
}

export function getCustomerEmail(customer) {
  if (!customer) return "";
  if (customer.email && String(customer.email).trim().includes("@")) {
    return String(customer.email).trim();
  }
  for (const row of parseContactRows(customer.contact)) {
    if (row?.email && String(row.email).trim().includes("@")) {
      return String(row.email).trim();
    }
  }
  return "";
}

export function getCustomerPhone(customer) {
  if (!customer) return "";
  const p1 = String(customer.phone1 || "").trim();
  if (p1) return p1;
  const p2 = String(customer.phone2 || "").trim();
  if (p2) return p2;
  for (const row of parseContactRows(customer.contact)) {
    const n = row?.contactNo || row?.phone || row?.mobile;
    if (n && String(n).trim()) return String(n).trim();
  }
  return "";
}

/**
 * @returns {{ ok: boolean, missingEmail: boolean, missingPhone: boolean, message: string|null }}
 */
export function getCustomerNotificationIssues(customer, {
  sendEmail = false,
  sendWhatsapp = false,
  customerEmailFallback = "",
} = {}) {
  const email =
    String(customerEmailFallback || "").trim() || getCustomerEmail(customer);
  const phone = getCustomerPhone(customer);

  const missingEmail = sendEmail && !email;
  const missingPhone = sendWhatsapp && !phone;
  const ok = !missingEmail && !missingPhone;

  if (ok) {
    return { ok: true, missingEmail: false, missingPhone: false, message: null };
  }

  const parts = [];
  if (missingEmail) parts.push("email address");
  if (missingPhone) parts.push("phone number for WhatsApp");

  return {
    ok: false,
    missingEmail,
    missingPhone,
    message: `This customer does not have ${parts.join(" or ")}. They will not receive the notification.`,
  };
}
